import React from 'react'

const Explore = () => {
  return (
    <div>
        {/* EXPLORE SECTION STARTS HERE */}
        <section class="explore" id="catergory">
            <h2>Explore By Category</h2>
            <p>We have grouped similar talents to aid you explore</p>

            <div class="steps">
                <a>
                    <div class="explore1">
                        <h4>UI/UX Design</h4>
                        <p>35+ Posted New Jobs</p>
                    </div>
                </a>

                <a>
                    <div class="explore1">
                        <h4>Digital Marketing</h4>
                        <p>45+ Posted New Jobs</p>
                    </div>
                </a>

                <a>
                    <div class="explore1">
                        <h4>Product Design</h4>
                        <p>60+ Posted New Jobs</p>
                    </div>
                </a>

                <a>
                    <div class="explore1">
                        <h4>Web Design</h4>
                        <p>100+ Posted New Jobs</p>
                    </div>
                </a>


                <a>
                    <div class="explore1">
                        <h4>Graphic Design</h4>
                        <p>60+ Posted New Jobs</p>
                    </div>
                </a>

                <a>
                    <div class="explore1">
                        <h4>Web Development</h4>
                        <p>35+ Posted New Jobs</p>
                    </div>
                </a>

                <a>
                    <div class="explore1">
                        <h4>Animation</h4>
                        <p>30+ Posted New Jobs</p>
                    </div>
                </a>


                
            </div>
        </section>

   {/* EXPLORE SECTION ENDS HERE  */}

    </div>
  )
}

export default Explore